import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { gr } from "../tokens";
import icons from "../icons";
import GrIcon from "./GrIcon";
import GrIconButton from "./GrIconButton";

// A photo shown large (tap on an attachment / post photo): the whole picture on a white card,
// never cropped, at most the screen height; labelled close button in the corner.
export default function GrImageDialog({ open, onClose, src, alt = "" }) {
  return (
    <Dialog
      open={!!open && !!src}
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{ sx: { background: gr.color.overlay } }}
      PaperProps={{
        sx: {
          position: "relative",
          m: gr.space[4],
          p: gr.space[2],
          maxWidth: `calc(100vw - ${gr.space[8]})`,
          borderRadius: gr.radius.card,
          boxShadow: gr.shadow.raised,
          backgroundImage: "none",
          background: gr.color.surface,
        },
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          display: "block",
          maxWidth: "100%",
          maxHeight: `calc(100vh - ${gr.space[12]} * 2)`,
          objectFit: "contain",
          borderRadius: gr.radius.tile,
        }}
      />
      <GrIconButton
        aria-label="Close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: gr.space[3],
          right: gr.space[3],
          borderRadius: gr.radius.pill,
          boxShadow: gr.shadow.raised,
        }}
      >
        <GrIcon icon={icons.close} />
      </GrIconButton>
    </Dialog>
  );
}

GrImageDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  src: PropTypes.string,
  alt: PropTypes.string,
};
